export enum ErrorType {
  Forbidden = 'forbidden',
  NotFound = 'notFound',
  UserDisallowed = 'userDisallowed',
  UpdateVersion = 'updateVersion',
  UserConcurrence = 'userConcurrence',
  NoCompetitions = 'noCompetitions',
  Event = 'event',
  Custom = 'custom',
  Default = 'default'
}

export enum LayoutType {
  Default = 'default',
  Full = 'full'
}
